import { useAuthContext, PageInfo, PagesApi } from '@pull/pull-groupm-csp-api'
import { FC, useEffect } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { Link } from 'react-router-dom'
import { MenuComponent } from '../../../../_metronic/assets/ts/components'
import { QUERIES } from '../../../Constants/Queries'
import { Delete } from '../../../helpers/functions/SwalHelpers'

type Props = {
  item: PageInfo
}

const PagesActionCell: FC<Props> = ({ item }) => {
  const { getApiConfiguration } = useAuthContext();
  const apiConfig = getApiConfiguration();
  const pagesApi = new PagesApi(apiConfig);

  const queryClient = useQueryClient();

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const deleteOnClick = () => {
    Delete("content page")
      .then(async (result) => {
        if (result.isConfirmed) {
          await deleteItem.mutateAsync()
        }
      })
  }


  const deleteItem = useMutation(() => pagesApi.apiPagesIdDelete(item.id ?? 0), {
    // 💡 response of the mutation is passed to onSuccess
    onSuccess: () => {
      // ✅ update detail view directly
      queryClient.invalidateQueries([QUERIES.PAGES.SEARCH])
    },
  })

  return (
    <div className="text-end">
      <Link to={`/pages/${item.id}`} className="btn btn-bg-light btn-color-gray-700 btn-active-color-info btn-sm px-4 me-2">Details</Link>
      <button type="button"
        className="btn btn-bg-light btn-color-gray-700 btn-active-color-danger btn-sm px-4"
        data-delete-news-item=""
        onClick={deleteOnClick}>Delete</button>
    </div>
  )
}

export default PagesActionCell